import { FormContextValues } from '@dreryk/react-common';

import { GroupSessionsFormBean } from './GroupSessionsForm.types';

export const withAgeRestriction = (
   controller: FormContextValues<GroupSessionsFormBean & any>
): controller is FormContextValues<GroupSessionsFormBean & { ageRestrictionEnabled: true }> => {
   return controller.watch('ageRestrictionEnabled');
};
